module.exports = __webpack_public_path__ + "media/images/btn_arrow_green-616d9e3f4086068cc51d0789a8e328dd.svg";